module.exports = "/assets/5b6ec33c5191a1659c2556d9eb891df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VK.png
// module id = 3048
// module chunks = 0